import { Result } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BsShieldX } from 'react-icons/bs';

const NoAvailablePayment = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap p-6 w-full justify-center">
      <Result
        icon={<BsShieldX color="red" className="text-5xl text-gray-500" />}
        title={t('payment.noAvailablePayment.title')}
        subTitle={t('payment.noAvailablePayment.subtitle')}
      />
    </div>
  );
};

export default NoAvailablePayment;
